import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { APIURLCOT } from "../../../Config";
import { toast } from "react-toastify";
import moment from "moment";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import ClientDetailCTLoanDetail from "../../ClientDetailCTLoanDetail";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import OutstandingSummary from "../../OutstandingSummary";
import Outstanding from "../CashonTap/Outstanding";

function ReportCT() {
  const todayDate = new Date().toISOString().split("T")[0];
  const token = localStorage.getItem("token");

  // Calculate the date 7 days before today
  const sevenDaysBeforeDate = new Date();
  sevenDaysBeforeDate.setDate(1);
  const formattedSevenDaysBeforeDate = sevenDaysBeforeDate
    .toISOString()
    .split("T")[0];

  const emailid = localStorage.getItem("emailId");
  const [isLoader, setIsLoader] = useState(false);
  const [totalWithdraw, setTotalWithdraw] = useState([]);
  const [summaryData, setSummaryData] = useState([]);

  const [totalWithdrawPending, setTotalWithdrawPending] = useState();
  const [totalRepayment, setTotalRepayment] = useState([]);
  const [selectDate, setSelectDate] = useState(false);
  const [withdrawDateValue1, setWithdrawDateValue1] = useState(todayDate); // Default to today’s date
  const [withdrawDateValue2, setWithdrawDateValue2] = useState(
    formattedSevenDaysBeforeDate
  );
  const [repaymentDateValue1, setRepaymentDateValue1] = useState(todayDate);
  const [repaymentDateValue2, setRepaymentDateValue2] = useState(
    formattedSevenDaysBeforeDate
  );
  const [summaryPaidDateValue1, setSummaryPaidDateValue1] = useState(todayDate);
  const [summaryPaidDateValue2, setSummaryPaidDateValue2] = useState(
    formattedSevenDaysBeforeDate
  );
  const [disDateValue1, setDisDateValue1] = useState(todayDate);
  const [disDateValue2, setDisDateValue2] = useState(
    formattedSevenDaysBeforeDate
  );

  const [drsSummaryPaidDateValue1, setDRSSummaryPaidDateValue1] =
    useState(todayDate);

  const [drsSummaryPaidDateValue2, setDRSSummaryPaidDateValue2] = useState(
    formattedSevenDaysBeforeDate
  );
  const [month, setMonth] = useState(0);
  const [months, setMonths] = useState([]);
  const [activeTab, setActiveTab] = useState("profile");
  const [withdrawPendingData, setWithdrawPendingData] = useState([]);
  const [withdrawData, setWithdrawData] = useState([]);
  const [repaymentData, setRepaymentData] = useState([]);
  const [outstandingData, setOutstandingData] = useState([]);
  const [summaryPaidData, setSummaryPaidData] = useState([]);
  const [totalOutstanding, setTotalOutstanding] = useState();
  const [drsSummaryPaid, setDRSSummaryPaid] = useState([]);
  const [width, setWidth] = React.useState(window.innerWidth < 768);
  const [data, setData] = useState([]);
  const [lid, setLid] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const getMonthName = (date) =>
    date.toLocaleString("default", { month: "long" });
  const tableDisbursementReport = React.useRef(null);
  const tableSummaryPaid = React.useRef(null);
  const tableDRSSummaryPaid = React.useRef(null);

  const tableWithdrawal = React.useRef(null);
  const tableWithdrawPending = React.useRef(null);
  const tableRepayment = React.useRef(null);
  const tableOutstanding = React.useRef(null);

  useEffect(() => {
    const now = new Date();
    const currentYear = now.getFullYear();

    const monthsArray = [];
    for (let i = 0; i < 3; i++) {
      const monthDate = new Date(currentYear, now.getMonth() - i, 1);
      const monthName = getMonthName(monthDate);
      monthsArray.push({
        name: `${monthName} ${currentYear}`,
        value: i.toString(),
      });
    }

    setMonths(monthsArray);
    setMonth("0");
  }, []);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const handleSubmit = () => {
    withdrawList();
  };
  const handleSubmitDis = () => {
    disbursementReport();
  };
  const handleSubmitRepayment = () => {
    repaymentList();
  };

  const handleSummaryPaid = () => {
    summaryPaidList();
  };

  const handleDRSSummaryPaid = () => {
    getDRSSummaryPaid();
  };

  useEffect(() => {
    if (activeTab === "profile") {
      disbursementReport();
    }
    if (activeTab === "withdraw-pending") {
      withdrawPendingList();
    }
    if (activeTab === "withdrawal") {
      setSelectDate(false);
      const todayDate = new Date();
      setWithdrawDateValue1(moment(todayDate).format("YYYY-MM-DD"));
      const sevenDaysBeforeDate = new Date();
      sevenDaysBeforeDate.setDate(1);
      setWithdrawDateValue2(moment(sevenDaysBeforeDate).format("YYYY-MM-DD"));
      withdrawList();
    }
    if (activeTab === "repayment") {
      setSelectDate(false);
      const todayDate = new Date();
      setRepaymentDateValue1(moment(todayDate).format("YYYY-MM-DD"));
      const sevenDaysBeforeDate = new Date();
      sevenDaysBeforeDate.setDate(1);
      setRepaymentDateValue2(moment(sevenDaysBeforeDate).format("YYYY-MM-DD"));
      repaymentList();
    }
    if (activeTab === "outstanding") {
      outstandingList();
    }
    if (activeTab === "summaryPaidList") {
      setSelectDate(false);
      const todayDate = new Date();
      setSummaryPaidDateValue1(moment(todayDate).format("YYYY-MM-DD"));
      const sevenDaysBeforeDate = new Date();
      sevenDaysBeforeDate.setDate(1);
      setSummaryPaidDateValue2(
        moment(sevenDaysBeforeDate).format("YYYY-MM-DD")
      );
      summaryPaidList();
    }
    if (activeTab === "paidDRS") {
      setSelectDate(false);
      const todayDate = new Date();
      setDRSSummaryPaidDateValue1(moment(todayDate).format("YYYY-MM-DD"));
      const sevenDaysBeforeDate = new Date();
      sevenDaysBeforeDate.setDate(1);
      setDRSSummaryPaidDateValue2(
        moment(sevenDaysBeforeDate).format("YYYY-MM-DD")
      );
      getDRSSummaryPaid();
    }
  }, [activeTab]);

  const disbursementReport = () => {
    // const data = { email: email, status: month };
    setIsLoader(true);
    axios
      .request(
        `${APIURLCOT}/disbursementReport/${disDateValue2}/${disDateValue1}`,
        {
          method: "GET",
          headers: {
            Authentication: token,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setIsLoader(false);
        console.log("response", response);
        setData(response?.data);
      })
      .catch((error) => {
        console.log("error", error);
        setIsLoader(false);
      });
  };

  const totalWithdrawAmount = () => {
    setIsLoader(true);
    axios
      .request(`${APIURLCOT}/getTotalWithdrawAmounts`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setIsLoader(false);
        console.log("response total withdraw", response);
        setTotalWithdraw(response?.data);
      })
      .catch((error) => {
        console.log("error", error);
        setIsLoader(false);
      });
  };

  const totalRepayAmount = () => {
    setIsLoader(true);
    axios
      .request(`${APIURLCOT}/getTotalRepayAmounts`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setIsLoader(false);
        console.log("response total repay amount", response);
        setTotalRepayment(response?.data);
      })
      .catch((error) => {
        console.log("error", error);
        setIsLoader(false);
      });
  };

  useEffect(() => {
    totalRepayAmount();
    totalWithdrawAmount();
  }, []);

  const withdrawPendingList = () => {
    let sAmount = [];
    setIsLoader(true);
    axios
      .request(`${APIURLCOT}/getWithdrawPendingList`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setIsLoader(false);
        console.log("wp responsse:::::", response);
        setWithdrawPendingData(response?.data);
        response.data.map((row, index) => {
          sAmount.push(row.transactionAmount);
        });
        const total = sAmount.reduce((a, b) => a + b);
        setTotalWithdrawPending(total);
      })
      .catch((error) => {
        console.log("error: ", error);
        setIsLoader(false);
      });
  };

  const outstandingList = () => {
    setIsLoader(true);
    axios
      .request(`${APIURLCOT}/employeroutstanding/${month}`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setIsLoader(false);
        console.log("ots responsse:::::", response);
        setOutstandingData(response?.data?.disbursments);
        setTotalOutstanding(response?.data?.totalOutstanding);
      })
      .catch((error) => {
        console.log("error: ", error);
        setIsLoader(false);
      });
  };

  const withdrawList = () => {
    let wAmount = [];
    setIsLoader(true);
    axios
      .request(
        `${APIURLCOT}/getWithdrawals/${withdrawDateValue2}/${withdrawDateValue1}`,

        {
          method: "GET",
          headers: {
            Authentication: token,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setIsLoader(false);
        console.log("w responsse:::::", response);
        setWithdrawData(response?.data);
        // response.data.map((row, index) => {
        //   wAmount.push(row.amount);
        // });
        // const total = wAmount.reduce((a, b) => a + b);
        // setTotalWithdraw(total);
      })
      .catch((error) => {
        console.log("error: ", error);
        setIsLoader(false);
      });
  };

  const repaymentList = () => {
    let rAmount = [];
    setIsLoader(true);
    axios
      .request(
        `${APIURLCOT}/getRepayments/${repaymentDateValue2}/${repaymentDateValue1}`,
        {
          method: "GET",
          headers: {
            Authentication: token,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setIsLoader(false);
        console.log("rp responsse:::::", response);
        setRepaymentData(response?.data);
        // response.data.map((row, index) => {
        //   rAmount.push(row.amount);
        // });
        // const total = rAmount.reduce((a, b) => a + b);
        // setTotalRepayment(total);
      })
      .catch((error) => {
        console.log("error: ", error);
        setIsLoader(false);
      });
  };

  const getAccountApprovedPending = (item) => {
    const data = {
      id: item?.id,
      bankRefNo: item?.bankRefNo,
    };
    axios
      .request(`${APIURLCOT}/getAccountApprovedPending`, {
        method: "POST",
        data: data,
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        toast.success("Successfully..");
      })
      .catch((error) => {
        console.log("error", error);
        toast.warning("Invalid...");
      });
  };

  const getAccountFailedPending = (item) => {
    const data = {
      id: item?.id,
      bankRefNo: item?.bankRefNo,
    };
    axios
      .request(`${APIURLCOT}/getAccountFailedPending`, {
        method: "POST",
        data: data,
        headers: {
          Authentication: token,

          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        toast.success("Rejected...");
      })
      .catch((error) => {
        console.log("error", error);
        toast.warning("Invalid...");
      });
  };
  const summaryPaidList = () => {
    setIsLoader(true);
    axios
      .request(
        `${APIURLCOT}/getSummarypaid/${summaryPaidDateValue2}/${summaryPaidDateValue1}`,
        {
          method: "GET",
          headers: {
            Authentication: token,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setIsLoader(false);
        console.log("ots responsse:::::", response);
        setSummaryPaidData(response?.data);
      })
      .catch((error) => {
        console.log("error: ", error);
        setIsLoader(false);
      });
  };
  const getDRSSummaryPaid = () => {
    // const data = { email: email, status: month };
    setIsLoader(true);
    axios
      .request(
        `${APIURLCOT}/getDRSummarypaid/${drsSummaryPaidDateValue2}/${drsSummaryPaidDateValue1}`,
        {
          method: "GET",
          headers: {
            Authentication: token,
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        setIsLoader(false);
        console.log("response", response);
        setDRSSummaryPaid(response?.data);
      })
      .catch((error) => {
        console.log("error", error);
        setIsLoader(false);
      });
  };

  useEffect(() => {
    withdrawList();
  }, [withdrawDateValue1]);
  useEffect(() => {
    repaymentList();
  }, [repaymentDateValue1]);
  useEffect(() => {
    disbursementReport();
    summaryPaidList();
  }, []);

  return (
    <div className={width ? "" : "p-3"}>
      <div>
        <ul className="nav nav-tabs-CT" id="myTabs" role="tablist">
          <li
            className={width ? "nav-item mt-2" : "nav-item"}
            role="presentation"
          >
            {/* <button
              className={`nav-link nav-itm-CT tab-item ${
                activeTab === "summary" ? "active" : ""
              }`}
              id="summary"
              data-bs-toggle="tab"
              data-bs-target="#summary"
              type="button"
              role="tab"
              aria-controls="summary"
              aria-selected={activeTab === "summary"}
              onClick={() => {
                handleTabClick("summary");
                setShowSearch(false);
              }}
            >
              Summary
            </button> */}
          </li>
          <li
            className={width ? "nav-item mt-2" : "nav-item"}
            role="presentation"
          >
            <button
              className={`nav-link nav-itm-CT tab-item ${
                activeTab === "profile" ? "active" : ""
              }`}
              id="profile"
              data-bs-toggle="tab"
              data-bs-target="#profile"
              type="button"
              role="tab"
              aria-controls="profile"
              aria-selected={activeTab === "profile"}
              onClick={() => {
                handleTabClick("profile");
                setShowSearch(false);
              }}
            >
              Disbursement
            </button>
          </li>

          <li
            className={width ? "nav-item mt-2" : "nav-item"}
            role="presentation"
          >
            <button
              className={`nav-link nav-itm-CT tab-item ${
                activeTab === "withdrawal" ? "active" : ""
              }`}
              id="withdrawal"
              data-bs-toggle="tab"
              data-bs-target="#withdrawal"
              type="button"
              role="tab"
              aria-controls="withdrawal"
              aria-selected={activeTab === "withdrawal"}
              onClick={() => {
                handleTabClick("withdrawal");
                setShowSearch(false);
              }}
            >
              Withdrawal
            </button>
          </li>

          <li
            className={width ? "nav-item mt-2" : "nav-item"}
            role="presentation"
          >
            <button
              className={`nav-link nav-itm-CT tab-item ${
                activeTab === "withdraw-pending" ? "active" : ""
              }`}
              id="withdrawal-pending"
              data-bs-toggle="tab"
              data-bs-target="#withdraw-pending"
              type="button"
              role="tab"
              aria-controls="withdraw-pending"
              aria-selected={activeTab === "withdraw-pending"}
              onClick={() => {
                handleTabClick("withdraw-pending");
                setShowSearch(false);
              }}
            >
              Transaction Pending
            </button>
          </li>
          <li
            className={width ? "nav-item mt-2" : "nav-item"}
            role="presentation"
          >
            <button
              className={`nav-link nav-itm-CT tab-item ${
                activeTab === "repayment" ? "active" : ""
              }`}
              id="repayment"
              data-bs-toggle="tab"
              data-bs-target="#repayment"
              type="button"
              role="tab"
              aria-controls="repayment"
              aria-selected={activeTab === "repayment"}
              onClick={() => {
                handleTabClick("repayment");
                setShowSearch(false);
              }}
            >
              Repayment
            </button>
          </li>
          {/* <li className="nav-item" role="presentation">
            <button
              className={`nav-link  tab-item ${
                activeTab === "outstanding" ? "active" : ""
              }`}
              id="outstanding"
              data-bs-toggle="tab"
              data-bs-target="#outstanding"
              type="button"
              role="tab"
              aria-controls="profile"
              aria-selected={activeTab === "outstanding"}
              onClick={() => handleTabClick("outstanding")}
            >
              Outstanding
            </button>
          </li> */}
          {/* <li className="nav-item" role="presentation">
            <button
              className={`nav-link nav-itm-CT tab-item ${
                activeTab === "empsummary" ? "active" : ""
              }`}
              id="empsummary"
              data-bs-toggle="tab"
              data-bs-target="#empsummary"
              type="button"
              role="tab"
              aria-controls="profile"
              aria-selected={activeTab === "empsummary"}
              onClick={() => handleTabClick("empsummary")}
            >
              Outstanding Summary
            </button>
          </li> */}

          <li
            className={width ? "nav-item mt-2" : "nav-item"}
            role="presentation"
          >
            <button
              className={`nav-link nav-itm-CT tab-item ${
                activeTab === "summaryPaidList" ? "active" : ""
              }`}
              id="summaryPaidList"
              data-bs-toggle="tab"
              data-bs-target="#summaryPaidList"
              type="button"
              role="tab"
              aria-controls="profile"
              aria-selected={activeTab === "summaryPaidList"}
              onClick={() => {
                handleTabClick("summaryPaidList");
                setShowSearch(false);
              }}
            >
              Account DCR
            </button>
          </li>
          <li
            className={width ? "nav-item mt-2" : "nav-item"}
            role="presentation"
          >
            <button
              className={`nav-link nav-itm-CT tab-item ${
                activeTab === "paidDRS" ? "active" : ""
              }`}
              id="paidDRS"
              data-bs-toggle="tab"
              data-bs-target="#paidDRS"
              type="button"
              role="tab"
              aria-controls="profile"
              aria-selected={activeTab === "paidDRS"}
              onClick={() => {
                handleTabClick("paidDRS");
                setShowSearch(false);
              }}
            >
              DCR Report
            </button>
          </li>
        </ul>
        <div className="tab-content mt-3" id="myTabsContent">
          {showSearch ? (
            <>
              <div className="p-3 d-flex justify-content-start mt-3">
                <button
                  className="btn btn-secondary"
                  style={{ width: "100px" }}
                  onClick={() => {
                    setShowSearch(false);
                  }}
                >
                  Back
                </button>
              </div>
              <div className="p-3 pt-2">
                <ClientDetailCTLoanDetail lid={lid} />
              </div>
            </>
          ) : (
            <>
              <div
                className={`tab-pane fade ${
                  activeTab === "summary" ? "show active" : ""
                }`}
                id="summary"
                role="tabpanel"
                aria-labelledby="summary"
              >
                <div className="pt-3">
                  <div className="card">
                    <div className="p-3 pt-4">
                      {isLoader ? (
                        <div className="d-flex justify-content-center">
                          <div
                            className="spinner-border text-success"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                      ) : (
                        <div
                          style={{
                            fontFamily: "PostGrotesk",
                            borderRadius: "10px",
                          }}
                        >
                          <div className="row mt-3">
                            <div className="col-lg-12 col-md-4 col-sm-12">
                              <div
                                className=""
                                style={{
                                  borderRadius: "0px",
                                  border: "2px solid #CACACA",
                                }}
                              >
                                <h5 className="p-2">Summary Details</h5>
                                <hr />
                                <table
                                  className="table table-striped m-0"
                                  style={{
                                    tableLayout: "fixed",
                                    border: "none",
                                  }}
                                >
                                  <tbody>
                                    <tr>
                                      <th style={{ border: "none" }}>Leads</th>

                                      <th style={{ border: "none" }}>
                                        {summaryData.branchId}
                                      </th>
                                    </tr>
                                    <tr>
                                      {" "}
                                      <th style={{ border: "none" }}>
                                        PD pending
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {summaryData.branchId}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        PD done today
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {summaryData.branchId}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        PD approved
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {summaryData.branchId}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        PD reject
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {summaryData.branchId}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        CA pending
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {summaryData.branchId}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        CA approved
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {summaryData.branchId}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        CA reject
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {summaryData.branchId}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Today disb
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {summaryData.branchId}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        MTD disb
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {summaryData.branchId}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Limit assigned count
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {summaryData.branchId}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Limit used count
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {summaryData.branchId}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Limit assigned amt
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {summaryData.branchId}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Limit used amt
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {summaryData.branchId}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Today withdrawal
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {summaryData.branchId}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        MTD withdrawal
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {summaryData.branchId}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Today coll
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {summaryData.branchId}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        MTD coll
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {summaryData.branchId}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Current OS
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {summaryData.branchId}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Unpaid count
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {summaryData.branchId}
                                      </th>
                                    </tr>
                                    <tr>
                                      <th style={{ border: "none" }}>
                                        Unpaid amt
                                      </th>
                                      <th style={{ border: "none" }}>
                                        {summaryData.branchId}
                                      </th>{" "}
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={`tab-pane fade ${
                  activeTab === "profile" ? "show active" : ""
                }`}
                id="profile"
                role="tabpanel"
                aria-labelledby="profile"
              >
                <div className="pt-3">
                  <div className="card">
                    <div className="p-3 pt-4">
                      <div className="mx-0 d-flex flex-column flex-md-row  justify-content-end">
                        <div className="d-flex flex-grow-1">
                          <DownloadTableExcel
                            filename="DisbursementReport"
                            sheet="users"
                            currentTableRef={tableDisbursementReport.current}
                          >
                            <button
                              className="btn btn-success mb-3 mb-md-0"
                              style={{
                                width: "120px",
                                backgroundColor: "black",
                              }}
                            >
                              Download
                            </button>
                          </DownloadTableExcel>
                        </div>
                        <div className="d-flex flex-column flex-md-row align-items-start">
                          <p className="mx-md-2 mb-1 mb-md-0 font-weight-bold">
                            Total today disb: {data[0]?.disbtoday}
                          </p>
                          <p className="mx-md-2 mb-1 mb-md-0 font-weight-bold">
                            Total disb month: {data[0]?.disbmonth}
                          </p>
                        </div>

                        {!selectDate ? (
                          <button
                            className="btn btn-info"
                            style={{ width: "150px" }}
                            onClick={() => setSelectDate(true)}
                          >
                            Select Date
                          </button>
                        ) : (
                          <div
                            className="d-flex flex-column flex-sm-row flex-wrap gap-2"
                            style={{ maxWidth: "500px", width: "100%" }}
                          >
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                              <div style={{ width: "175px" }}>
                                <DatePicker
                                  className="ml-2"
                                  label="From Date"
                                  value={
                                    disDateValue2
                                      ? new Date(disDateValue2)
                                      : null
                                  } // Ensure value is a Date object
                                  format="dd-MM-yyyy"
                                  onChange={(date) =>
                                    setDisDateValue2(
                                      date
                                        ? moment(date).format("YYYY-MM-DD")
                                        : null
                                    )
                                  }
                                  renderInput={(params) => (
                                    <TextField {...params} />
                                  )}
                                />
                              </div>
                              <div style={{ width: "175px" }}>
                                <DatePicker
                                  className="ml-2"
                                  label="To Date"
                                  format="dd-MM-yyyy"
                                  value={
                                    disDateValue1
                                      ? new Date(disDateValue1)
                                      : null
                                  } // Ensure value is a Date object
                                  onChange={(date) =>
                                    setDisDateValue1(
                                      date
                                        ? moment(date).format("YYYY-MM-DD")
                                        : null
                                    )
                                  }
                                  renderInput={(params) => (
                                    <TextField {...params} />
                                  )}
                                />
                              </div>
                            </LocalizationProvider>
                            <div className="mt-2 mx-2">
                              <button
                                className="btn btn-success"
                                style={{
                                  background: "black",
                                  width: "100px",
                                }}
                                onClick={() => handleSubmitDis()}
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        )}

                        {/* <div className="mt-2 mt-md-0 d-flex align-items-start align-items-md-center">
                          <select
                            className="form-select mx-0 mx-md-2 mb-2 mb-md-0 w-auto"
                            id="lang"
                            onChange={(e) => setMonth(e.target.value)}
                            value={month}
                          >
                            {months.map(({ name, value }) => (
                              <option key={value} value={value}>
                                {name}
                              </option>
                            ))}
                          </select>
                          <button
                            className="btn btn-success border ml-md-2"
                            style={{ background: "black", color: "#fff" }}
                            onClick={disbursementReport}
                          >
                            {isLoader ? (
                              <div
                                className="spinner-border text-light"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            ) : (
                              "Search"
                            )}
                          </button>
                        </div> */}
                      </div>

                      {isLoader ? (
                        <div className="d-flex justify-content-center">
                          <div
                            className="spinner-border text-success"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                      ) : (
                        <div className="table-responsive mt-3">
                          <table className="table table-striped">
                            <thead>
                              <tr>
                                <th style={{ textAlign: "center" }}>Sr. No</th>
                                <th style={{ textAlign: "center" }}>
                                  Dt. & time
                                </th>
                                <th style={{ textAlign: "center" }}>
                                  Client name{" "}
                                </th>
                                <th style={{ textAlign: "center" }}>
                                  Branch name
                                </th>

                                <th style={{ textAlign: "center" }}>Mobile</th>
                                <th style={{ textAlign: "center" }}>LID</th>
                                <th style={{ textAlign: "center" }}>
                                  Amt disbursed
                                </th>
                                {/* <th style={{ textAlign: "center" }}>
                                Total today disb
                              </th>
                              <th style={{ textAlign: "center" }}>
                                Total disb month
                              </th> */}
                              </tr>
                            </thead>
                            <tbody>
                              {data && data.length > 0 ? (
                                data.map((item, i) => (
                                  <tr key={i}>
                                    <td style={{ textAlign: "center" }}>
                                      {i + 1}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {new Date(item.datetime).toLocaleString(
                                        "en-GB"
                                      )}
                                    </td>
                                    <td
                                      style={
                                        {
                                          // textAlign: "center",
                                          // whiteSpace: "normal",
                                          // fontSize: "15px",
                                          // color: "blue",
                                          // cursor: "pointer",
                                        }
                                      }
                                    >
                                      {item.clientname}
                                    </td>
                                    <td>{item.branchName || "-"}</td>

                                    {/* <td>{item.employername}</td> */}
                                    <td style={{ textAlign: "center" }}>
                                      {item.mobile}
                                    </td>
                                    <td
                                      style={{
                                        color: "blue",
                                        cursor: "pointer",
                                        textAlign: "center",
                                      }}
                                      onClick={() => {
                                        if (item.loanid) {
                                          setLid(item.loanid);
                                          setShowSearch(true);
                                        }
                                      }}
                                    >
                                      {item.loanid}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.amtdisb}
                                    </td>
                                    {/* <td style={{ textAlign: "center" }}>
                                    {item.totaldisb}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    {item.totaldisbmonth}
                                  </td> */}
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan="100%"
                                    style={{
                                      textAlign: "center",
                                      padding: "10px",
                                    }}
                                  >
                                    No data available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <table
                  className="table table-striped mt-3 "
                  style={{ display: "none" }}
                  ref={tableDisbursementReport}
                >
                  <thead>
                    <tr>
                      <th style={{ textAlign: "center" }}>Sr. No</th>
                      <th style={{ textAlign: "center" }}>Dt. & time</th>
                      <th style={{ textAlign: "center" }}>Employee name </th>
                      <th style={{ textAlign: "center" }}>Branch name </th>
                      {/* <th style={{ textAlign: "center" }}>Employer name</th> */}

                      <th style={{ textAlign: "center" }}>Mobile</th>
                      <th style={{ textAlign: "center" }}>LID</th>
                      <th style={{ textAlign: "center" }}>Amt disbursed</th>
                      {/* <th style={{ textAlign: "center" }}>
                                Total today disb
                              </th>
                              <th style={{ textAlign: "center" }}>
                                Total disb month
                              </th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {data &&
                      data.map((item, i) => (
                        <tr key={i}>
                          <td style={{ textAlign: "center" }}>{i + 1}</td>
                          <td>
                            {new Date(item.dttime).toLocaleString("en-GB")}
                          </td>
                          <td
                            style={
                              {
                                // textAlign: "center",
                                // whiteSpace: "normal",
                                // fontSize: "15px",
                                // color: "blue",
                                // cursor: "pointer",
                              }
                            }
                          >
                            {item.clientname}
                          </td>
                          <td>{item.branchName}</td>
                          <td style={{ textAlign: "center" }}>{item.mobile}</td>
                          <td
                            style={{
                              color: "blue",
                              cursor: "pointer",
                              textAlign: "center",
                            }}
                            onClick={() => {
                              if (item.loanid) {
                                setLid(item.loanid);
                                setShowSearch(true);
                              }
                            }}
                          >
                            {item.loanid}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.amtdisb}
                          </td>
                          {/* <td style={{ textAlign: "center" }}>
                                    {item.totaldisb}
                                  </td>
                                  <td style={{ textAlign: "center" }}>
                                    {item.totaldisbmonth}
                                  </td> */}
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>

              <div
                className={`tab-pane fade ${
                  activeTab === "withdraw-pending" ? "show active" : ""
                }`}
                id="withdraw-pending"
                role="tabpanel"
                aria-labelledby="withdraw-pending"
              >
                <div className="pt-3">
                  <div className="card">
                    <div className="p-3 pt-4">
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <DownloadTableExcel
                            filename="DisbursementReport"
                            sheet="users"
                            currentTableRef={tableWithdrawPending.current}
                          >
                            <button
                              className="btn btn-success"
                              style={{
                                width: "120px",
                                backgroundColor: "black",
                              }}
                            >
                              Download
                            </button>
                          </DownloadTableExcel>
                        </div>
                        {/* <div>
                          <p className="mb-0 font-weight-bold">
                            Total Transaction Amount: {totalWithdrawPending}
                          </p>
                        </div> */}
                      </div>

                      {isLoader ? (
                        <div className="d-flex justify-content-center">
                          <div
                            className="spinner-border text-success"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                      ) : (
                        <div className="table-responsive mt-3">
                          <table
                            className="table table-striped mt-3 "
                            // style={{ display: "none" }}
                            ref={tableWithdrawPending}
                          >
                            <thead>
                              <tr>
                                <th style={{ textAlign: "center" }}>Sr. No</th>
                                <th style={{ textAlign: "center" }}>Loan Id</th>
                                <th style={{ textAlign: "center" }}>
                                  Transaction Date
                                </th>
                                {/* <th style={{ textAlign: "center" }}>
                                  Month Transaction Id{" "}
                                </th> */}
                                <th style={{ textAlign: "center" }}>
                                  Transaction Amount
                                </th>
                                {/* <th style={{ textAlign: "center" }}>
                                  Due Amount
                                </th>
                                <th style={{ textAlign: "center" }}>
                                  Transaction Type
                                </th>
                                <th style={{ textAlign: "center" }}>
                                  Transaction status
                                </th> */}
                                {/* <th style={{ textAlign: "center" }}>
                                  Transaction Month
                                </th>
                                <th style={{ textAlign: "center" }}>
                                  Transaction Year
                                </th> */}
                                {/* <th style={{ textAlign: "center" }}>GST</th>
                                <th style={{ textAlign: "center" }}>
                                  Sanction Amount
                                </th>
                                <th style={{ textAlign: "center" }}>
                                  RepInstId
                                </th> */}

                                {/* <th style={{ textAlign: "center" }}>
                                  Processing Fee
                                </th> */}
                                <th style={{ textAlign: "center" }}>
                                  Bank Ref No
                                </th>
                                <th style={{ textAlign: "center" }}>
                                  Payment Made By
                                </th>

                                <th style={{ textAlign: "center" }}>
                                  CTL Status
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {withdrawPendingData &&
                              withdrawPendingData.length > 0 ? (
                                withdrawPendingData.map((item, i) => (
                                  <tr key={i}>
                                    <td style={{ textAlign: "center" }}>
                                      {i + 1}
                                    </td>
                                    <td
                                      style={{
                                        color: "blue",
                                        cursor: "pointer",
                                        textAlign: "center",
                                      }}
                                      onClick={() => {
                                        if (item.loanid) {
                                          setLid(item.loanid);
                                          setShowSearch(true);
                                        }
                                      }}
                                    >
                                      {item.loanid}
                                    </td>
                                    <td
                                      style={{
                                        textAlign: "center",
                                      }}
                                    >
                                      {new Date(
                                        item.transactionDate
                                      ).toLocaleString("en-GB")}
                                    </td>
                                    {/* <td style={{ textAlign: "center" }}>
                                      {item.monthTransactionId}
                                    </td> */}
                                    <td style={{ textAlign: "center" }}>
                                      {item.transactionAmount}
                                    </td>
                                    {/* <td
                                      style={{
                                        textAlign: "center",
                                      }}
                                    >
                                      {item.dueAmount}
                                    </td> */}
                                    {/* <td style={{ textAlign: "center" }}>
                                      {item.transactionType}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.transactionStatus}
                                    </td> */}
                                    {/* <td style={{ textAlign: "center" }}>
                                      {item.tMonth}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.tYear}
                                    </td> */}
                                    {/* <td style={{ textAlign: "center" }}>
                                      {item.gst}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.sanctionAmount}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.repInstId}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.processingFee}
                                    </td> */}
                                    <td style={{ textAlign: "center" }}>
                                      {item.bankRefNo}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.paymentMadeBy}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {/* {item.ctlStatus} */}
                                      <button
                                        className="btn btn-success"
                                        onClick={() =>
                                          getAccountApprovedPending(item)
                                        }
                                      >
                                        Approve
                                      </button>
                                      <button
                                        className="btn btn-danger"
                                        onClick={() =>
                                          getAccountFailedPending(item)
                                        }
                                      >
                                        Reject
                                      </button>
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan="100%"
                                    style={{
                                      textAlign: "center",
                                      padding: "10px",
                                    }}
                                  >
                                    No data available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      )}
                      <table
                        className="table table-striped mt-3 "
                        style={{ display: "none" }}
                      >
                        <thead>
                          <tr>
                            <th style={{ textAlign: "center" }}>Sr. No</th>
                            <th style={{ textAlign: "center" }}>Loan Id</th>
                            <th style={{ textAlign: "center" }}>
                              Transaction Date
                            </th>
                            <th style={{ textAlign: "center" }}>Branch Name</th>
                            <th style={{ textAlign: "center" }}>
                              Transaction Amount
                            </th>
                            <th style={{ textAlign: "center" }}>Due Amount</th>
                            <th style={{ textAlign: "center" }}>
                              Transaction Type
                            </th>
                            <th style={{ textAlign: "center" }}>
                              Transaction status
                            </th>
                            {/* <th style={{ textAlign: "center" }}>
                              Transaction Month
                            </th>
                            <th style={{ textAlign: "center" }}>
                              Transaction Year
                            </th> */}
                            <th style={{ textAlign: "center" }}>GST</th>
                            <th style={{ textAlign: "center" }}>
                              Sanction Amount
                            </th>
                            <th style={{ textAlign: "center" }}>RepInstId</th>

                            <th style={{ textAlign: "center" }}>
                              Processing Fee
                            </th>
                            <th style={{ textAlign: "center" }}>Bank Ref No</th>
                            <th style={{ textAlign: "center" }}>
                              Payment Made By
                            </th>

                            <th style={{ textAlign: "center" }}>CTL Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {withdrawPendingData.map((item, i) => (
                            <tr key={i}>
                              <td style={{ textAlign: "center" }}>{i + 1}</td>
                              <td style={{ textAlign: "center" }}>
                                {item.loanid}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                {new Date(item.transactionDate).toLocaleString(
                                  "en-GB"
                                )}
                              </td>
                              <td>{item?.branchName}</td>
                              <td style={{ textAlign: "center" }}>
                                {item.transactionAmount}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                {item.dueAmount}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {item.transactionType}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {item.transactionStatus}
                              </td>

                              {/* <td style={{ textAlign: "center" }}>
                                {item.tMonth}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {item.tYear}
                              </td> */}
                              <td style={{ textAlign: "center" }}>
                                {item.gst}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {item.sanctionAmount}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {item.repInstId}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {item.processingFee}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {item.bankRefNo}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {item.paymentMadeBy}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {/* {item.ctlStatus} */}
                                <button
                                  className="btn btn-success"
                                  onClick={() =>
                                    getAccountApprovedPending(item)
                                  }
                                >
                                  Success
                                </button>
                                <button
                                  className="btn btn-danger"
                                  onClick={() => getAccountFailedPending(item)}
                                >
                                  Fail
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`tab-pane fade ${
                  activeTab === "withdrawal" ? "show active" : ""
                }`}
                id="withdrawal"
                role="tabpanel"
                aria-labelledby="withdrawal"
              >
                <div className="pt-3">
                  <div className="card">
                    <div className="p-3 pt-4">
                      <div className="d-flex justify-content-between flex-wrap">
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <DownloadTableExcel
                              filename="DisbursementReport"
                              sheet="users"
                              currentTableRef={tableWithdrawal.current}
                            >
                              <button
                                className="btn btn-success"
                                style={{
                                  width: "120px",
                                  backgroundColor: "black",
                                }}
                              >
                                Download
                              </button>
                            </DownloadTableExcel>
                          </div>
                        </div>

                        <div className="d-flex flex-wrap gap-2">
                          <div className="my-auto mr-3 ml-1">
                            <p className="mb-0 font-weight-bold">
                              Today Withdraw:{" "}
                              {withdrawData[0]?.todayRepayment || 0}
                            </p>
                          </div>
                          <div className="my-auto mr-3">
                            <p className="mb-0 font-weight-bold">
                              Month Withdraw: {withdrawData[0]?.monthRepayment}
                            </p>
                          </div>
                          {!selectDate ? (
                            <button
                              className="btn btn-info"
                              style={{ width: "150px" }}
                              onClick={() => setSelectDate(true)}
                            >
                              Select Date
                            </button>
                          ) : (
                            <div
                              className="d-flex flex-column flex-sm-row flex-wrap gap-2"
                              style={{ maxWidth: "500px", width: "100%" }}
                            >
                              <LocalizationProvider
                                dateAdapter={AdapterDateFns}
                              >
                                <div>
                                  <DatePicker
                                    className="ml-2"
                                    label="From Date"
                                    value={
                                      withdrawDateValue2
                                        ? new Date(withdrawDateValue2)
                                        : null
                                    } // Ensure value is a Date object
                                    format="dd-MM-yyyy"
                                    onChange={(date) =>
                                      setWithdrawDateValue2(
                                        date
                                          ? moment(date).format("YYYY-MM-DD")
                                          : null
                                      )
                                    }
                                    renderInput={(params) => (
                                      <TextField {...params} />
                                    )}
                                  />
                                </div>
                                <div>
                                  <DatePicker
                                    className="ml-2"
                                    label="To Date"
                                    value={
                                      withdrawDateValue1
                                        ? new Date(withdrawDateValue1)
                                        : null
                                    } // Ensure value is a Date object
                                    format="dd-MM-yyyy"
                                    onChange={(date) =>
                                      setWithdrawDateValue1(
                                        date
                                          ? moment(date).format("YYYY-MM-DD")
                                          : null
                                      )
                                    }
                                    renderInput={(params) => (
                                      <TextField {...params} />
                                    )}
                                  />
                                </div>
                              </LocalizationProvider>
                              <div className="mt-2 mx-2">
                                <button
                                  className="btn btn-success"
                                  style={{
                                    background: "black",
                                    width: "100px",
                                  }}
                                  onClick={() => handleSubmit()}
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      {isLoader ? (
                        <div className="d-flex justify-content-center">
                          <div
                            className="spinner-border text-success"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                      ) : (
                        <div className="table-responsive mt-3">
                          <table
                            className="table table-striped mt-3 "
                            // style={{ display: "none" }}
                            // ref={tableDisbursementReport}
                          >
                            <thead>
                              <tr>
                                <th style={{ textAlign: "center" }}>Sr. No</th>
                                <th style={{ textAlign: "center" }}>
                                  Txn Date
                                </th>
                                <th style={{ textAlign: "center" }}>Name</th>
                                <th style={{ textAlign: "center" }}>
                                  Branch Name
                                </th>
                                <th style={{ textAlign: "center" }}>Mobile</th>
                                <th style={{ textAlign: "center" }}>LID</th>
                                <th style={{ textAlign: "center" }}>Amount</th>
                                <th style={{ textAlign: "center" }}>Mode</th>
                              </tr>
                            </thead>
                            <tbody>
                              {withdrawData && withdrawData.length > 0 ? (
                                withdrawData.map((item, i) => (
                                  <tr key={i}>
                                    <td style={{ textAlign: "center" }}>
                                      {i + 1}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {new Date(item.txndate).toLocaleString(
                                        "en-GB"
                                      )}
                                    </td>

                                    <td>{item.name}</td>
                                    <td>{item?.branchName}</td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.mobileno}
                                    </td>
                                    <td
                                      style={{
                                        color: "blue",
                                        cursor: "pointer",
                                        textAlign: "center",
                                      }}
                                      onClick={() => {
                                        if (item.loanid) {
                                          setLid(item.loanid);
                                          setShowSearch(true);
                                        }
                                      }}
                                    >
                                      {item.loanid}
                                    </td>

                                    <td style={{ textAlign: "center" }}>
                                      {item.amount}
                                    </td>
                                    <td>{item?.code}</td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan="100%"
                                    style={{
                                      textAlign: "center",
                                      padding: "10px",
                                    }}
                                  >
                                    No data available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      )}
                      <table
                        className="table table-striped mt-3 "
                        style={{ display: "none" }}
                        ref={tableWithdrawal}
                      >
                        <thead>
                          <tr>
                            <th style={{ textAlign: "center" }}>Sr. No</th>
                            <th style={{ textAlign: "center" }}>Txn Date</th>
                            <th style={{ textAlign: "center" }}>Name</th>
                            <th style={{ textAlign: "center" }}>Branch Name</th>
                            <th style={{ textAlign: "center" }}>Mobile</th>
                            <th style={{ textAlign: "center" }}>LID</th>
                            <th style={{ textAlign: "center" }}>Amount</th>
                            <th style={{ textAlign: "center" }}>Mode</th>
                          </tr>
                        </thead>
                        <tbody>
                          {withdrawData.map((item, i) => (
                            <tr key={i}>
                              <td style={{ textAlign: "center" }}>{i + 1}</td>
                              <td style={{ textAlign: "center" }}>
                                {new Date(item.txndate).toLocaleString("en-GB")}
                              </td>

                              <td>{item.name}</td>
                              <td>{item.branchName}</td>
                              <td style={{ textAlign: "center" }}>
                                {item.mobileno}
                              </td>
                              <td
                                style={{
                                  // color: "blue",
                                  // cursor: "pointer",
                                  textAlign: "center",
                                }}
                                // onClick={() => {
                                //   if (item.lid) {
                                //     setLid(item.lid);
                                //     setShowSearch(true);
                                //   }
                                // }}
                              >
                                {item.loanid}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {item.amount}
                              </td>
                              <td>{item?.code}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`tab-pane fade ${
                  activeTab === "repayment" ? "show active" : ""
                }`}
                id="repayment"
                role="tabpanel"
                aria-labelledby="repayment"
              >
                <div className="pt-3">
                  <div className="card">
                    <div className="p-3 pt-4">
                      <div className="d-flex justify-content-between flex-wrap">
                        <div className="d-flex flex-grow-1">
                          <DownloadTableExcel
                            filename="DisbursementReport"
                            sheet="users"
                            currentTableRef={tableRepayment.current}
                          >
                            <button
                              className="btn btn-success mb-3 mb-md-0"
                              style={{
                                width: "120px",
                                backgroundColor: "black",
                              }}
                            >
                              Download
                            </button>
                          </DownloadTableExcel>
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                          <div className="my-auto mr-3 ml-1">
                            <p className="mb-0 font-weight-bold">
                              Today Repayment:{" "}
                              {repaymentData[0]?.todayRepayment || 0}
                            </p>
                          </div>
                          <div className="my-auto mr-3">
                            <p className="mb-0 font-weight-bold">
                              Month Repayment:{" "}
                              {repaymentData[0]?.monthRepayment}
                            </p>
                          </div>
                          {!selectDate ? (
                            <button
                              className="btn btn-info"
                              style={{ width: "150px" }}
                              onClick={() => setSelectDate(true)}
                            >
                              Select Date
                            </button>
                          ) : (
                            <div className="d-flex flex-wrap gap-2">
                              <LocalizationProvider
                                dateAdapter={AdapterDateFns}
                              >
                                <div style={{ width: "175px" }}>
                                  <DatePicker
                                    className="ml-2"
                                    label="From Date"
                                    value={
                                      repaymentDateValue2
                                        ? new Date(repaymentDateValue2)
                                        : null
                                    } // Ensure value is a Date object
                                    format="dd-MM-yyyy"
                                    onChange={(date) =>
                                      setRepaymentDateValue2(
                                        date
                                          ? moment(date).format("YYYY-MM-DD")
                                          : null
                                      )
                                    }
                                    renderInput={(params) => (
                                      <TextField {...params} />
                                    )}
                                  />
                                </div>
                                <div style={{ width: "175px" }}>
                                  <DatePicker
                                    className="ml-2"
                                    label="To Date"
                                    value={
                                      repaymentDateValue1
                                        ? new Date(repaymentDateValue1)
                                        : null
                                    } // Ensure value is a Date object
                                    format="dd-MM-yyyy"
                                    onChange={(date) =>
                                      setRepaymentDateValue1(
                                        date
                                          ? moment(date).format("YYYY-MM-DD")
                                          : null
                                      )
                                    }
                                    renderInput={(params) => (
                                      <TextField {...params} />
                                    )}
                                  />
                                </div>
                              </LocalizationProvider>
                              <div className="mt-2 mx-2">
                                <button
                                  className="btn btn-success"
                                  style={{
                                    background: "black",
                                    width: "100px",
                                  }}
                                  onClick={() => handleSubmitRepayment()}
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      {isLoader ? (
                        <div className="d-flex justify-content-center">
                          <div
                            className="spinner-border text-success"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                      ) : (
                        <div className="table-responsive mt-3">
                          <table
                            className="table table-striped mt-3 "
                            // style={{ display: "none" }}
                            // ref={tableDisbursementReport}
                          >
                            <thead>
                              <tr>
                                <th style={{ textAlign: "center" }}>Sr. No</th>
                                <th style={{ textAlign: "center" }}>
                                  Txn Date
                                </th>
                                <th style={{ textAlign: "center" }}>Name</th>
                                <th style={{ textAlign: "center" }}>
                                  Branch Name
                                </th>
                                <th style={{ textAlign: "center" }}>Mobile</th>
                                <th style={{ textAlign: "center" }}>LID</th>
                                <th style={{ textAlign: "center" }}>Amount</th>
                                <th style={{ textAlign: "center" }}>Mode</th>
                              </tr>
                            </thead>
                            <tbody>
                              {repaymentData && repaymentData.length > 0 ? (
                                repaymentData.map((item, i) => (
                                  <tr key={i}>
                                    <td style={{ textAlign: "center" }}>
                                      {i + 1}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {new Date(item.txndate).toLocaleString(
                                        "en-GB"
                                      )}
                                    </td>

                                    <td>{item.name}</td>
                                    <td>{item?.branchName}</td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.mobileno}
                                    </td>
                                    <td
                                      style={{
                                        color: "blue",
                                        cursor: "pointer",
                                        textAlign: "center",
                                      }}
                                      onClick={() => {
                                        if (item.loanid) {
                                          setLid(item.loanid);
                                          setShowSearch(true);
                                        }
                                      }}
                                    >
                                      {item.loanid}
                                    </td>

                                    <td style={{ textAlign: "center" }}>
                                      {item.amount}
                                    </td>
                                    <td>{item?.code}</td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan="100%"
                                    style={{
                                      textAlign: "center",
                                      padding: "10px",
                                    }}
                                  >
                                    No data available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      )}
                      <table
                        className="table table-striped mt-3 "
                        style={{ display: "none" }}
                        ref={tableRepayment}
                      >
                        <thead>
                          <tr>
                            <th style={{ textAlign: "center" }}>Sr. No</th>
                            <th style={{ textAlign: "center" }}>Txn Date</th>
                            <th style={{ textAlign: "center" }}>App Id </th>
                            <th style={{ textAlign: "center" }}>Name</th>
                            <th style={{ textAlign: "center" }}>Branch Name</th>
                            <th style={{ textAlign: "center" }}>Mobile</th>
                            <th style={{ textAlign: "center" }}>LID</th>
                            <th style={{ textAlign: "center" }}>Amount</th>
                            <th style={{ textAlign: "center" }}>Mode</th>
                          </tr>
                        </thead>
                        <tbody>
                          {repaymentData.map((item, i) => (
                            <tr key={i}>
                              <td style={{ textAlign: "center" }}>{i + 1}</td>
                              <td style={{ textAlign: "center" }}>
                                {new Date(item.txndate).toLocaleString("en-GB")}
                              </td>
                              <td
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                {item.appid}
                              </td>
                              <td>{item.name}</td>
                              <td>{item?.branchName}</td>
                              <td style={{ textAlign: "center" }}>
                                {item.mobileno}
                              </td>
                              <td
                                style={{
                                  // color: "blue",
                                  // cursor: "pointer",
                                  textAlign: "center",
                                }}
                                // onClick={() => {
                                //   if (item.lid) {
                                //     setLid(item.lid);
                                //     setShowSearch(true);
                                //   }
                                // }}
                              >
                                {item.loanid}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {item.amount}
                              </td>
                              <td>{item?.code}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`tab-pane fade ${
                  activeTab === "outstanding" ? "show active" : ""
                }`}
                id="outstanding"
                role="tabpanel"
                aria-labelledby="profile"
              >
                <div className="pt-3">
                  <div className="card">
                    <div className="p-3 pt-4">
                      <div className="mx-0 d-flex flex-column flex-md-row align-items-center justify-content-end">
                        <div className="d-flex flex-grow-1">
                          <DownloadTableExcel
                            filename="OutstandingReport"
                            sheet="users"
                            currentTableRef={tableOutstanding.current}
                          >
                            <button
                              className="btn btn-success mb-3 mb-md-0"
                              style={{
                                width: "120px",
                                backgroundColor: "black",
                              }}
                            >
                              Download
                            </button>
                          </DownloadTableExcel>
                        </div>
                        <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                          <p className="mx-md-2 mb-1 mb-md-0 font-weight-bold">
                            Total Outstanding : {totalOutstanding}
                          </p>
                          {/* <p className="mx-md-2 mb-1 mb-md-0 font-weight-bold">
                            Total disb month: {data[0]?.disbmonth}
                          </p> */}
                        </div>
                        <div className="mt-2 mt-md-0 d-flex align-items-start align-items-md-center">
                          <select
                            className="form-select mx-0 mx-md-2 mb-2 mb-md-0 w-auto"
                            id="lang"
                            onChange={(e) => setMonth(e.target.value)}
                            value={month}
                          >
                            {months.map(({ name, value }) => (
                              <option key={value} value={value}>
                                {name}
                              </option>
                            ))}
                          </select>
                          <button
                            className="btn btn-success border ml-md-2"
                            style={{ background: "black", color: "#fff" }}
                            onClick={outstandingList}
                          >
                            {isLoader ? (
                              <div
                                className="spinner-border text-light"
                                role="status"
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            ) : (
                              "Search"
                            )}
                          </button>
                        </div>
                      </div>

                      {isLoader ? (
                        <div className="d-flex justify-content-center">
                          <div
                            className="spinner-border text-success"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                      ) : (
                        <div className="table-responsive mt-3">
                          <table className="table table-striped">
                            <thead>
                              <tr>
                                <th style={{ textAlign: "center" }}>Sr. No</th>

                                <th style={{ textAlign: "center" }}>
                                  Client name{" "}
                                </th>
                                <th style={{ textAlign: "center" }}>LID</th>
                                <th style={{ textAlign: "center" }}>Mobile</th>

                                <th style={{ textAlign: "center" }}>
                                  Amt disbursed
                                </th>
                                <th style={{ textAlign: "center" }}>
                                  Repayment Amt
                                </th>
                                <th style={{ textAlign: "center" }}>
                                  Outstanding Amt
                                </th>

                                <th style={{ textAlign: "center" }}>
                                  OneTime Setup Fees
                                </th>
                                <th style={{ textAlign: "center" }}>
                                  Convenience fees
                                </th>
                                <th style={{ textAlign: "center" }}>
                                  Limit assigned
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {outstandingData && outstandingData.length > 0 ? (
                                outstandingData.map((item, i) => (
                                  <tr key={i}>
                                    <td style={{ textAlign: "center" }}>
                                      {i + 1}
                                    </td>

                                    <td style={{ textAlign: "left" }}>
                                      {item.empname}
                                    </td>

                                    <td
                                      style={{
                                        color: "blue",
                                        cursor: "pointer",
                                        textAlign: "center",
                                      }}
                                      onClick={() => {
                                        if (item.lid) {
                                          setLid(item.lid);
                                          setShowSearch(true);
                                        }
                                      }}
                                    >
                                      {item.lid}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.mobile}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.amtdisb}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.repayamt}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.outstandingamt}
                                    </td>

                                    <td style={{ textAlign: "center" }}>
                                      {item.onetimesetup}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.convfees}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.limitassigned}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan="100%"
                                    style={{
                                      textAlign: "center",
                                      padding: "10px",
                                    }}
                                  >
                                    No data available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <table
                  className="table table-striped mt-3 "
                  style={{ display: "none" }}
                  ref={tableOutstanding}
                >
                  <thead>
                    <tr>
                      <th style={{ textAlign: "center" }}>Sr. No</th>
                      <th style={{ textAlign: "center" }}>Employee name </th>
                      <th style={{ textAlign: "center" }}>LID</th>
                      <th style={{ textAlign: "center" }}>Mobile</th>

                      <th style={{ textAlign: "center" }}>Amt disbursed</th>
                      <th style={{ textAlign: "center" }}>Repayment Amt</th>
                      <th style={{ textAlign: "center" }}>Outstanding Amt</th>

                      <th style={{ textAlign: "center" }}>
                        OneTime Setup Fees
                      </th>
                      <th style={{ textAlign: "center" }}>Convenience fees</th>
                      <th style={{ textAlign: "center" }}>Limit assigned</th>
                    </tr>
                  </thead>
                  <tbody>
                    {outstandingData &&
                      outstandingData.length > 0 &&
                      outstandingData.map((item, i) => (
                        <tr key={i}>
                          <td style={{ textAlign: "center" }}>{i + 1}</td>

                          <td style={{}}>{item.empname}</td>

                          <td
                            style={{
                              color: "blue",
                              cursor: "pointer",
                              textAlign: "center",
                            }}
                            onClick={() => {
                              if (item.lid) {
                                setLid(item.lid);
                                setShowSearch(true);
                              }
                            }}
                          >
                            {item.lid}
                          </td>
                          <td style={{ textAlign: "center" }}>{item.mobile}</td>
                          <td style={{ textAlign: "center" }}>
                            {item.amtdisb}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.repayamt}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.outstandingamt}
                          </td>

                          <td style={{ textAlign: "center" }}>
                            {item.onetimesetup}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.convfees}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.limitassigned}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>

              {/* <div
                className={`tab-pane fade ${
                  activeTab === "empsummary" ? "show active" : ""
                }`}
                id="empsummary"
                role="tabpanel"
                aria-labelledby="profile"
              >
                <Outstanding />
              </div> */}

              <div
                className={`tab-pane fade ${
                  activeTab === "summaryPaidList" ? "show active" : ""
                }`}
                id="summaryPaidList"
                role="tabpanel"
                aria-labelledby="summaryPaidList"
              >
                <div className="pt-3">
                  <div className="card">
                    <div className="p-3 pt-4">
                      <div className="d-flex flex-wrap">
                        <div className="flex-grow-1">
                          <DownloadTableExcel
                            filename="SummaryPaidReport"
                            sheet="users"
                            currentTableRef={tableSummaryPaid.current}
                          >
                            <button
                              className="btn btn-success mb-3 mb-md-0"
                              style={{
                                width: "120px",
                                backgroundColor: "black",
                              }}
                            >
                              Download
                            </button>
                          </DownloadTableExcel>
                        </div>
                        <div className="d-flex flex-wrap flex-grow-2">
                          {!selectDate ? (
                            <button
                              className="btn btn-info"
                              style={{ width: "150px" }}
                              onClick={() => setSelectDate(true)}
                            >
                              Select Date
                            </button>
                          ) : (
                            <div className="d-flex flex-wrap">
                              <LocalizationProvider
                                dateAdapter={AdapterDateFns}
                              >
                                <div>
                                  <DatePicker
                                    className="ml-2"
                                    label="From Date"
                                    value={
                                      summaryPaidDateValue2
                                        ? new Date(summaryPaidDateValue2)
                                        : null
                                    } // Ensure value is a Date object
                                    format="dd-MM-yyyy"
                                    onChange={(date) =>
                                      setSummaryPaidDateValue2(
                                        date
                                          ? moment(date).format("YYYY-MM-DD")
                                          : null
                                      )
                                    }
                                    renderInput={(params) => (
                                      <TextField {...params} />
                                    )}
                                  />
                                </div>
                                <div>
                                  <DatePicker
                                    className="ml-2"
                                    label="To Date"
                                    value={
                                      summaryPaidDateValue1
                                        ? new Date(summaryPaidDateValue1)
                                        : null
                                    } // Ensure value is a Date object
                                    format="dd-MM-yyyy"
                                    onChange={(date) =>
                                      setSummaryPaidDateValue1(
                                        date
                                          ? moment(date).format("YYYY-MM-DD")
                                          : null
                                      )
                                    }
                                    renderInput={(params) => (
                                      <TextField {...params} />
                                    )}
                                  />
                                </div>
                              </LocalizationProvider>
                              <div className="mt-2 mx-2">
                                <button
                                  className="btn btn-success"
                                  style={{
                                    background: "black",
                                    width: "100px",
                                  }}
                                  onClick={() => handleSummaryPaid()}
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      {isLoader ? (
                        <div className="d-flex justify-content-center">
                          <div
                            className="spinner-border text-success"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                      ) : (
                        <div className="table-responsive mt-3">
                          <table className="table table-striped">
                            <thead>
                              <tr>
                                <th style={{ textAlign: "center" }}>Sr. No</th>
                                <th style={{ textAlign: "center" }}>
                                  Receipt Date
                                </th>
                                <th style={{ textAlign: "center" }}>
                                  Transaction Id
                                </th>
                                <th style={{ textAlign: "center" }}>
                                  Corporate Name
                                </th>
                                <th style={{ textAlign: "center" }}>
                                  Branch Name
                                </th>
                                <th style={{ textAlign: "center" }}>Loan ID</th>

                                <th style={{ textAlign: "center" }}>
                                  Client Name
                                </th>
                                <th style={{ textAlign: "center" }}>
                                  Receipt Amount
                                </th>

                                <th style={{ textAlign: "center" }}>
                                  Receipt No
                                </th>

                                <th style={{ textAlign: "center" }}>
                                  Split Amount
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              {summaryPaidData && summaryPaidData.length > 0 ? (
                                summaryPaidData.map((item, i) => (
                                  <tr key={i}>
                                    <td style={{ textAlign: "center" }}>
                                      {i + 1}
                                    </td>
                                    <td>{item.receiptdate}</td>
                                    <td>{item.txnid}</td>
                                    <td style={{ textAlign: "left" }}>
                                      {item.corporatename}
                                    </td>
                                    <td>{item.branchName}</td>

                                    <td
                                      style={{
                                        color: "blue",
                                        cursor: "pointer",
                                        textAlign: "center",
                                      }}
                                      onClick={() => {
                                        if (item.loanid) {
                                          setLid(item.loanid);
                                          setShowSearch(true);
                                        }
                                      }}
                                    >
                                      {item.loanid}
                                    </td>

                                    <td>{item.clientname}</td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.receiptamount}
                                    </td>

                                    <td style={{ textAlign: "center" }}>
                                      {item.receiptno || "N/A"}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.splitamount}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan="100%"
                                    style={{
                                      textAlign: "center",
                                      padding: "10px",
                                    }}
                                  >
                                    No data available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                    <table
                      className="table table-striped mt-3 "
                      style={{ display: "none" }}
                      ref={tableSummaryPaid}
                    >
                      <thead>
                        <tr>
                          <th style={{ textAlign: "center" }}>Sr. No</th>
                          <th style={{ textAlign: "center" }}>Receipt Date</th>
                          <th style={{ textAlign: "center" }}>
                            Transaction Id
                          </th>
                          <th style={{ textAlign: "center" }}>
                            Corporate Name
                          </th>
                          <th style={{ textAlign: "center" }}>Branch Name</th>
                          <th style={{ textAlign: "center" }}>Loan ID</th>

                          <th style={{ textAlign: "center" }}>Client Name</th>
                          <th style={{ textAlign: "center" }}>
                            Receipt Amount
                          </th>

                          <th style={{ textAlign: "center" }}>Receipt No</th>

                          <th style={{ textAlign: "center" }}>Split Amount</th>
                        </tr>
                      </thead>

                      <tbody>
                        {summaryPaidData.map((item, i) => (
                          <tr key={i}>
                            <td style={{ textAlign: "center" }}>{i + 1}</td>
                            <td>{item.receiptdate}</td>
                            <td>{item.txnid}</td>
                            <td style={{ textAlign: "left" }}>
                              {item.corporatename}
                            </td>

                            <td style={{ textAlign: "left" }}>
                              {item?.branchName}
                            </td>
                            <td
                              style={{
                                color: "blue",
                                cursor: "pointer",
                                textAlign: "center",
                              }}
                              onClick={() => {
                                if (item.loanid) {
                                  setLid(item.loanid);
                                  setShowSearch(true);
                                }
                              }}
                            >
                              {item.loanid}
                            </td>

                            <td>{item.clientname}</td>
                            <td style={{ textAlign: "center" }}>
                              {item.receiptamount}
                            </td>

                            <td style={{ textAlign: "center" }}>
                              {item.receiptno || "N/A"}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {item.splitamount}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div
                className={`tab-pane fade ${
                  activeTab === "paidDRS" ? "show active" : ""
                }`}
                id="paidDRS"
                role="tabpanel"
                aria-labelledby="paidDRS"
              >
                <div className="pt-3">
                  <div className="card">
                    <div className="p-3 pt-4">
                      <div className="d-flex flex-wrap">
                        <div className="flex-grow-1">
                          <DownloadTableExcel
                            filename="DRSSummaryPaidReport"
                            sheet="users"
                            currentTableRef={tableDRSSummaryPaid.current}
                          >
                            <button
                              className="btn btn-success mb-3 mb-md-0"
                              style={{
                                width: "120px",
                                backgroundColor: "black",
                              }}
                            >
                              Download
                            </button>
                          </DownloadTableExcel>
                        </div>
                        <div className="d-flex justify-content-end">
                          {!selectDate ? (
                            <button
                              className="btn btn-info"
                              style={{ width: "150px" }}
                              onClick={() => setSelectDate(true)}
                            >
                              Select Date
                            </button>
                          ) : (
                            <div className="d-flex flex-wrap">
                              <LocalizationProvider
                                dateAdapter={AdapterDateFns}
                              >
                                <div>
                                  <DatePicker
                                    className="ml-2"
                                    label="From Date"
                                    value={
                                      drsSummaryPaidDateValue2
                                        ? new Date(drsSummaryPaidDateValue2)
                                        : null
                                    } // Ensure value is a Date object
                                    format="dd-MM-yyyy"
                                    onChange={(date) =>
                                      setDRSSummaryPaidDateValue2(
                                        date
                                          ? moment(date).format("YYYY-MM-DD")
                                          : null
                                      )
                                    }
                                    renderInput={(params) => (
                                      <TextField {...params} />
                                    )}
                                  />
                                </div>
                                <div>
                                  <DatePicker
                                    className="ml-2"
                                    label="To Date"
                                    value={
                                      drsSummaryPaidDateValue1
                                        ? new Date(drsSummaryPaidDateValue1)
                                        : null
                                    } // Ensure value is a Date object
                                    format="dd-MM-yyyy"
                                    onChange={(date) =>
                                      setDRSSummaryPaidDateValue1(
                                        date
                                          ? moment(date).format("YYYY-MM-DD")
                                          : null
                                      )
                                    }
                                    renderInput={(params) => (
                                      <TextField {...params} />
                                    )}
                                  />
                                </div>
                              </LocalizationProvider>
                              <div className="mt-2 mx-2">
                                <button
                                  className="btn btn-success"
                                  style={{
                                    background: "black",
                                    width: "100px",
                                  }}
                                  onClick={handleDRSSummaryPaid}
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      {isLoader ? (
                        <div className="d-flex justify-content-center">
                          <div
                            className="spinner-border text-success"
                            role="status"
                          >
                            <span className="sr-only">Loading...</span>
                          </div>
                        </div>
                      ) : (
                        <div className="table-responsive mt-3">
                          <table className="table table-striped">
                            <thead>
                              <tr>
                                <th style={{ textAlign: "center" }}>Sr. No</th>
                                <th style={{ textAlign: "center" }}>
                                  Receipt Date
                                </th>
                                <th style={{ textAlign: "center" }}>
                                  Client Name
                                </th>
                                <th style={{ textAlign: "center" }}>
                                  Branch name
                                </th>
                                <th style={{ textAlign: "center" }}>Loan ID</th>
                                <th style={{ textAlign: "center" }}>
                                  Receipt Amount
                                </th>
                                <th style={{ textAlign: "center" }}>
                                  CTL DR No
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {drsSummaryPaid.length > 0 ? (
                                drsSummaryPaid.map((item, i) => (
                                  <tr key={i}>
                                    <td style={{ textAlign: "center" }}>
                                      {i + 1}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.receiptdate}
                                    </td>
                                    <td style={{ textAlign: "left" }}>
                                      {item.client_name}
                                    </td>
                                    <td>{item?.branchName}</td>
                                    <td
                                      style={{
                                        color: "blue",
                                        cursor: "pointer",
                                        textAlign: "center",
                                      }}
                                      onClick={() => {
                                        if (item.ctl_loanid) {
                                          setLid(item.ctl_loanid);
                                          setShowSearch(true);
                                        }
                                      }}
                                    >
                                      {item.ctl_loanid}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.receipt_amount}
                                    </td>
                                    <td style={{ textAlign: "center" }}>
                                      {item.ctl_drno ? item.ctl_drno : "N/A"}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan="7"
                                    style={{ textAlign: "center" }}
                                  >
                                    No data available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                    <table
                      className="table table-striped mt-3 "
                      style={{ display: "none" }}
                      ref={tableDRSSummaryPaid}
                    >
                      <thead>
                        <tr>
                          <th style={{ textAlign: "center" }}>Sr. No</th>
                          <th style={{ textAlign: "center" }}>Receipt Date</th>

                          <th style={{ textAlign: "center" }}>Client Name</th>
                          <th style={{ textAlign: "center" }}>Branch name</th>
                          <th style={{ textAlign: "center" }}>Loan ID</th>
                          <th style={{ textAlign: "center" }}>
                            Receipt Amount
                          </th>

                          <th style={{ textAlign: "center" }}>CTL DR No</th>
                        </tr>
                      </thead>
                      <tbody>
                        {drsSummaryPaid.length > 0 ? (
                          drsSummaryPaid.map((item, i) => (
                            <tr key={item}>
                              <td style={{ textAlign: "center" }}>{i + 1}</td>
                              <td style={{ textAlign: "center" }}>
                                {item.receiptdate}
                              </td>
                              <td style={{ textAlign: "left" }}>
                                {item.client_name}
                              </td>
                              <td>{item?.branchName}</td>
                              {/* <td style={{ textAlign: "center" }}>
                                {item.transaction_id}
                              </td> */}
                              <td
                                style={{
                                  color: "blue",
                                  cursor: "pointer",
                                  textAlign: "center",
                                }}
                                onClick={() => {
                                  if (item.ctl_loanid) {
                                    setLid(item.ctl_loanid);
                                    setShowSearch(true);
                                  }
                                }}
                              >
                                {item.ctl_loanid}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {item.receipt_amount}
                              </td>

                              <td style={{ textAlign: "center" }}>
                                {item.ctl_drno ? item.ctl_drno : "N/A"}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="6">No data available</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default ReportCT;
